import { graphql } from '@/generated/gql';

export const PUBLISH_RULE_VERSION = graphql(/* GraphQL */ `
  mutation RuleVersionPublish($id: UUID!, $versionId: UUID!) {
    tesseract {
      rule(id: $id) {
        publish(ruleVersionId: $versionId) {
          id
          status
        }
      }
    }
  }
`);

export const PAUSE_RULE_VERSION = graphql(/* GraphQL */ `
  mutation RuleVersionPause($id: UUID!) {
    tesseract {
      rule(id: $id) {
        pause {
          id
          status
        }
      }
    }
  }
`);

export const SAVE_RULE_VERSION = graphql(/* GraphQL */ `
  mutation RuleVersionSave($id: UUID!, $graph: JSON!) {
    tesseract {
      rule(id: $id) {
        ruleVersion {
          save(graph: $graph) {
            id
            ruleId
            graph
          }
        }
      }
    }
  }
`);
